export default __webpack_public_path__ + "static/media/pflege.e6c5e9bc.webp";